export default {
  shipmentHelpers: (state) => state.shipmentHelpers,
  shipmentStatusFilters: (state) => state.shipmentStatusFilters,
  shipment: (state) => state.shipment
}



// WEBPACK FOOTER //
// ./src/components/shipment/store/getters.js